import { render, staticRenderFns } from "./AuthRisk.vue?vue&type=template&id=58eeafc4&scoped=true"
import script from "./AuthRisk.vue?vue&type=script&lang=js"
export * from "./AuthRisk.vue?vue&type=script&lang=js"
import style0 from "./AuthRisk.vue?vue&type=style&index=0&id=58eeafc4&prod&lang=less&scoped=true"
import style1 from "./AuthRisk.vue?vue&type=style&index=1&id=58eeafc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eeafc4",
  null
  
)

export default component.exports